import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import Topnav from '../../components/adminNav/Topnav'
import Sidebar from '../../components/sidebar/Sidebar'
import { publicRequest, TOKEN, BASE_URL } from '../../requestMethod';

export default function Dashboard() {
  const user = useSelector((state) => state.user.currentUser);;
  useEffect(() => {
    const getDatas = async () => {
      try {
        //const res = await publicRequest.get("Dashboard");
        const res = await axios.get(`${BASE_URL}Dashboard`, {
          mode: 'no-cors',
          headers: { 'Authorization': `Bearer ${user.returnObj.token}` }
        })
        setAllDatas(res.data);
      }
      catch (err) {
        console.log(err)
      }
    }
    getDatas();
  }, []);
  const [allData, setAllDatas] = useState([])
  return (
    <div className="container-scroller">

      <Topnav />
      {/* partial */}
      <div className="container-fluid page-body-wrapper">
        {/* partial:partials/_sidebar.html */}
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="page-header">
              <h3 className="page-title">
                <span className="page-title-icon bg-gradient-primary text-white me-2">
                  <i className="mdi mdi-home" />
                </span> Dashboard
              </h3>
              <nav aria-label="breadcrumb">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item active" aria-current="page">
                    <span />Overview <i className="mdi mdi-alert-circle-outline icon-sm text-primary align-middle" />
                  </li>
                </ul>
              </nav>
            </div>
            <div className="row">
              <div className="col-md-4 stretch-card grid-margin">
                <div className="card bg-gradient-danger card-img-holder text-white">
                  <div className="card-body">
                    <img src="assets/images/dashboard/circle.svg" className="card-img-absolute" alt="circle-image" />
                    <h4 className="font-weight-normal mb-3">Weekly Sales <i className="mdi mdi-chart-line mdi-24px float-right" />
                    </h4>
                    <h2 className="mb-5">NGN {allData.moneyMadeThisWeek}</h2>
                    <h6 className="card-text">Increased by 60%</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-4 stretch-card grid-margin">
                <div className="card bg-gradient-info card-img-holder text-white">
                  <div className="card-body">
                    <img src="assets/images/dashboard/circle.svg" className="card-img-absolute" alt="circle-image" />
                    <h4 className="font-weight-normal mb-3">Current Orders <i className="mdi mdi-bookmark-outline mdi-24px float-right" />
                    </h4>
                    <h2 className="mb-5">{allData.inProgressOrders}</h2>
                    <h6 className="card-text">Decreased by 10%</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-4 stretch-card grid-margin">
                <div className="card bg-gradient-success card-img-holder text-white">
                  <div className="card-body">
                    <img src="assets/images/dashboard/circle.svg" className="card-img-absolute" alt="circle-image" />
                    <h4 className="font-weight-normal mb-3">Money This Month <i className="mdi mdi-diamond mdi-24px float-right" />
                    </h4>
                    <h2 className="mb-5">NGN{allData.moneyMadeThisMonth}</h2>
                    <h6 className="card-text">Increased by 5%</h6>
                  </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-md-4 stretch-card grid-margin">
                <div className="card bg-gradient-danger card-img-holder text-white">
                  <div className="card-body">
                    <img src="assets/images/dashboard/circle.svg" className="card-img-absolute" alt="circle-image" />
                    <h4 className="font-weight-normal mb-3">Total Sales <i className="mdi mdi-chart-line mdi-24px float-right" />
                    </h4>
                    <h2 className="mb-5">NGN {allData.totalMoneyMade}</h2>
                    <h6 className="card-text">Increased by 60%</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-4 stretch-card grid-margin">
                <div className="card bg-gradient-info card-img-holder text-white">
                  <div className="card-body">
                    <img src="assets/images/dashboard/circle.svg" className="card-img-absolute" alt="circle-image" />
                    <h4 className="font-weight-normal mb-3">Total Orders <i className="mdi mdi-bookmark-outline mdi-24px float-right" />
                    </h4>
                    <h2 className="mb-5">{allData.totalOrderAlltime}</h2>
                    <h6 className="card-text">Decreased by 10%</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-4 stretch-card grid-margin">
                <div className="card bg-gradient-success card-img-holder text-white">
                  <div className="card-body">
                    <img src="assets/images/dashboard/circle.svg" className="card-img-absolute" alt="circle-image" />
                    <h4 className="font-weight-normal mb-3">Total UntreatedBasket <i className="mdi mdi-diamond mdi-24px float-right" />
                    </h4>
                    <h2 className="mb-5">{allData.untreatedBaskets}</h2>
                  </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-md-7 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <div className="clearfix">
                      <h4 className="card-title float-left">Visit And Sales Statistics</h4>
                      <div id="visit-sale-chart-legend" className="rounded-legend legend-horizontal legend-top-right float-right" />
                    </div>
                    <canvas id="visit-sale-chart" className="mt-4" />
                  </div>
                </div>
              </div>
              <div className="col-md-5 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Traffic Sources</h4>
                    <canvas id="traffic-chart" />
                    <div id="traffic-chart-legend" className="rounded-legend legend-vertical legend-bottom-left pt-4" />
                  </div>
                </div>
              </div>
            </div>



          </div>

        </div>
        {/* main-panel ends */}
      </div>
      {/* page-body-wrapper ends */}
    </div>
  )
}
